module.exports = __webpack_public_path__ + "static/img/h6-2.d22bcb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd101/h6-2.png
// module id = O4ve
// module chunks = 1